'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBar = function (_React$Component) {
	_inherits(SearchBar, _React$Component);

	function SearchBar(props) {
		_classCallCheck(this, SearchBar);

		var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

		_this.onChange = _this.onChange.bind(_this);
		_this.onEnterKeyDown = _this.onEnterKeyDown.bind(_this);
		return _this;
	}

	_createClass(SearchBar, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.changeTimeout) {
				clearTimeout(this.changeTimeout);
				this.changeTimeout = null;
			}
		}
	}, {
		key: 'onChange',
		value: function onChange(e) {
			var _props = this.props,
			    throttle = _props.throttle,
			    onChange = _props.onChange;

			if (!onChange) {
				return;
			}
			var value = e.target.value;
			if (!throttle) {
				onChange(value);
			} else {
				if (this.changeTimeout) {
					clearTimeout(this.changeTimeout);
					this.changeTimeout = null;
				}
				// throttle the change events based on this.props.throttle value in ms
				this.changeTimeout = setTimeout(function () {
					onChange(value);
				}, throttle);
			}
		}
	}, {
		key: 'onEnterKeyDown',
		value: function onEnterKeyDown(e) {
			if (this.props.onSubmit) {
				this.props.onSubmit(e.target.value);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    placeholder = _props2.placeholder,
			    value = _props2.value,
			    defaultValue = _props2.defaultValue,
			    className = _props2.className;

			var classes = (0, _classnames2.default)(className, 'search-bar');
			return _react2.default.createElement(
				'div',
				{ className: classes },
				_react2.default.createElement('span', { className: 'search-bar-icon' }),
				_react2.default.createElement(_reactBootstrap.FormControl, {
					type: 'text',
					placeholder: placeholder,
					onChange: this.onChange,
					value: value,
					defaultValue: defaultValue,
					onKeyDown: function onKeyDown(e) {
						return (0, _accessibilityUtils.OnKey)(e, [_accessibilityUtils.Keys.enter], _this2.onEnterKeyDown);
					},
					role: 'search'
				})
			);
		}
	}]);

	return SearchBar;
}(_react2.default.Component);

SearchBar.propTypes = {
	placeholder: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	onSubmit: _propTypes2.default.func,
	value: _propTypes2.default.string,
	defaultValue: _propTypes2.default.string,
	/**
  * The number of ms to throttle the onChange callback.
  */
	throttle: _propTypes2.default.number
};

SearchBar.defaultProps = {
	throttle: 0, // ms
	placeholder: ''
};
var _default = SearchBar;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(SearchBar, 'SearchBar', 'src/components/SearchBar.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SearchBar.jsx');
}();

;